/** @jsx jsx */
import { css } from "@emotion/react";

import OjeitoShape from '../images/LP-versar/sociomeconal-shape.png'
import OjeitoShapeMobile from '../images/LP-versar/socioemocional-shape-mobile.svg'

export const oJeitoVersar = css`
background-color: #ffffff;
display: flex;
flex-direction: column;
padding-top: 104px;
padding-bottom: 153px;
/* background-image: url(${OjeitoShape});
background-repeat: no-repeat;
background-size: contain; */
background-position-x: 526px;
overflow: clip;

@media (max-width: 850px) {
  /* background-image: url(${OjeitoShapeMobile});
  background-position-x: center;
  background-size: contain;
  background-repeat: repeat; */
}



.title-container {
  display: flex;
  margin-bottom: 40px;
  font-family: "owners-narrow", sans-serif;
  font-weight: 700;
  width: 100%;
  max-width: 400px;
  .title {
    color: #484848;
    font-size: 60px;
    font-weight: 700;
    line-height: 100%;
    span {
      color: #776AAE;
    }
  }
}

.ebook-hand{
  position: absolute;
    top: 0;
    right: 110px;
    z-index: 1;

    @media (max-width: 768px) {
      display: none;
    }
}

.ebook-hand-mobile{
    display: none;
    width: 100%;
    @media (max-width: 768px) {
      display: block;
    }
}

.topics{
  border-radius: 48px;
  background-color: #CFC5E5;
  width: 100%;
  max-width: 570px;
  padding: 48px;
  font-family: Montserrat;
  color: #484848;
  font-size: 18px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
      margin-top: -90px;
    }

  ul{
    margin:0;
    padding: 0;
    li{
      margin:0;
      margin-bottom: 4px;
      ::before{
        content: '• ';
        color: #484848;
        font-weight: bold;
      }
    }
  }
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 37px;
  justify-content: center;
  width: 100%;
}
  
`
